var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
var Greeting = /** @class */ (function (_super) {
    __extends(Greeting, _super);
    function Greeting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getGreeting = function () {
            var date = new Date();
            var hour = date.getHours();
            if (hour < 12) {
                return "platform.greeting.morning";
            }
            if (hour < 17) {
                return "platform.greeting.afternoon";
            }
            return "platform.greeting.evening";
        };
        return _this;
    }
    Greeting.prototype.render = function () {
        var user = this.props.user;
        var firstname = user.firstName || user.firstname;
        return (React.createElement(FormattedMessage // eslint-disable-line
        , { id: this.getGreeting(), values: { firstname: firstname } }));
    };
    return Greeting;
}(PureComponent));
export default Greeting;
